import { render, staticRenderFns } from "./BookingTalentNotifications.vue?vue&type=template&id=10363d16"
import script from "./BookingTalentNotifications.vue?vue&type=script&lang=js"
export * from "./BookingTalentNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports